import { Matter } from '../types/matter';

const getNested = (obj: unknown, path: string): string | undefined => {
  if (!obj || typeof obj !== 'object') return undefined;
  const val = (obj as Record<string, unknown>)[path];
  return typeof val === 'string' ? val : undefined;
};

export const getClaimantName = (m: Matter): string => {
  const direct = getNested(m.claimant, 'name_surname');
  if (direct) return direct;
  return getNested(m.rafExtractedJson, 'claimant_name_surname') || '';
};

export const getClaimantNameOrDash = (m: Matter): string => getClaimantName(m) || '—';

export const getAccidentDate = (m: Matter): string => {
  const direct = getNested(m.accident, 'date');
  if (direct) return direct;
  return getNested(m.rafExtractedJson, 'accident_date') || '';
};

export const getIdNumber = (m: Matter): string =>
  getNested(m.claimant, 'id_or_passport_number') ||
  getNested(m.rafExtractedJson, 'claimant_id_or_passport_number') ||
  '';
